import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Question, Answer } from '@df/interfaces';

@Component({
    selector: 'app-pupil-question',
    templateUrl: './pupil-question.component.html',
    styleUrls: ['./pupil-question.component.scss']
})
export class PupilQuestionComponent implements OnInit {
    @Input() question: Question;
    @Input() questIndex: number;
    @Input() exercise;
    @Input() studentId: number;
    @Input() cardId: number;
    @Input() answer: Answer;

    @Output() questionAnsweredCorrectly = new EventEmitter();
    @Output() questionAnswer = new EventEmitter<Answer>();

    answerString: string = '';

    ngOnInit() {
        if (this.answer) {
            this.answerString = this.answer.shortAnswer;
        }
    }

    questionClearAnswer() {
        this.answerString = '';
    }

    keyboardQuestionClicked(word: string) {
        if (this.answerString === '') {
            this.answerString = word;
        } else {
            this.answerString = this.answerString + ', ' + word;
        }
    }

    questionCheckAnswer() {
        let isCorrect: boolean = false;
        // Check if answer is correct
        for (const answ of this.question.answers) {
            if (this.answerString === answ.shortAnswer || this.answerString === answ.fullAnswer) {
                isCorrect = true;
                break;
            }
        }

        const answer: Answer = {
            student: this.studentId,
            card: this.cardId,
            shortAnswer: this.answerString,
            exercise: this.exercise.id,
            correct: isCorrect,
            question: this.question.id
        };

        this.questionAnswer.emit(answer);
        if (isCorrect) {
            this.questionAnsweredCorrectly.emit(true);
        } else {
            this.questionAnsweredCorrectly.emit(false);
        }
    }
}
